<template>
	<header class="Header">
		<div class="Header-left">
			<a class="Header-logo" href="/">
				<img src="/map/dist/skin/logo.svg" alt="Logo"/>
			</a>
			<span v-if="isLoading" class="loading-container">
				<LoadingIndicator class="loading-indicator"/>
				Bezig met laden...
			</span>

		</div>
		<div class="Header-right">
			<Button
				v-if="allowedTo(['dashboard', 'dashboard/uitvoerdersploeg'])"
				@click="$router.push({name: 'dashboard'})"
			>Dashboard
			</Button>
			<Button
				v-if="allowedTo('map/support')"
				@click="setMapType('support')"
				:class="{ active: mapType === 'support' }"
			>Support
			</Button>
			<Button
				v-if="allowedTo('map/planning')"
				@click="setMapType('planning')"
				:class="{ active: mapType === 'planning' }"
			>Planning
			</Button>
			<Button
				v-if="allowedTo('map/appointments')"
				@click="setMapType('appointments')"
				:class="{ active: mapType === 'appointments' }"
			>Afspraken
			</Button>
			<Button
				v-if="allowedTo('map/uitvoering')"
				@click="setMapType('uitvoering')"
				:class="{ active: mapType === 'uitvoering' }"
			>Uitvoering
			</Button>
			<Button
				v-if="allowedTo('map/uitvoering-planning')"
				@click="setMapType('execution-appointments')"
				:class="{ active: mapType === 'execution-appointments' }"
			>Afspraken
			</Button>
			<Button
				v-if="allowedTo('map/marketing')"
				@click="setMapType('marketing')"
				:class="{ active: mapType === 'marketing' }"
			>Marketing
			</Button>
			<Button
				v-if="allowedTo('map/quality')"
				@click="setMapType('quality')"
				:class="{ active: mapType === 'quality' }"
			>Kwaliteit
			</Button>
			<Button
				v-if="allowedTo(['admin', 'admin/users', 'admin/sync', 'admin/geo', 'admin/colors'])"
				@click="$router.push({ name: 'admin' })"
			>Beheer
			</Button>
		</div>
	</header>
</template>

<script>
import Button from "@/components/Button.vue";
import DateField from "@/components/DateField.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import ToggleField from "@/components/ToggleField.vue";
import {mapGetters, mapMutations, mapState} from "vuex";

export default {
	components: {
		LoadingIndicator,
		Button,
		DateField,
		ToggleField,
	},
	computed: {
		...mapState({
			isLoading: "loading"
		}),
		...mapState("map", {
			mapType: "mapType"
		}),
		...mapGetters({
			allowedTo: "auth/allowedTo"
		}),
	},

	mounted() {
		if(this.mapType == null) {
			if (this.allowedTo("map/planning")) {
				this.setMapType("planning");
			} else if (this.allowedTo("map/uitvoering")) {
				this.setMapType("uitvoering");
			} else if (this.allowedTo("map/marketing")) {
				this.setMapType("marketing");
			} else if (this.allowedTo("map/appointments")) {
				this.setMapType("appointments");
			} else if (this.allowedTo("map/uitvoering-planning")) {
				this.setMapType("execution-appointments");
			} else if (this.allowedTo("map/support")) {
				this.setMapType("support");
			} else if (this.allowedTo("map/quality")) {
				this.setMapType("quality");
			}
		}
	},

	methods: {
		...mapMutations({
			setMapType: "map/setMapType"
		}),

	}
};
</script>

<style scoped lang="scss">
	.loading-container {
		color: #777777; font-size: 13px; position: absolute;

		.loading-indicator {
			height: 16px;
		}
	}
</style>
